import Vue from 'vue';
import { gsap } from 'gsap/all';
import FontFaceObserver from 'fontfaceobserver';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('project-detail-header-component', {
    data() {
        return {
            showOverlay: true,
        };
    },

    mounted() {
        Vue.nextTick(() => {
            gsap.delayedCall(0.2, () => {
                if (!ScrollTrigger.isInViewport(this.$el)) {
                    this.showOverlay = false;
                } else {
                    this.initReveal();
                }
            });
        });
    },

    methods: {
        initReveal() {
            const revealTl = gsap.timeline({ delay: 1 });

            revealTl.to('.project-detail__header-overlay', {
                duration: 1, y: '-100%', stagger: 0.2, ease: 'power3.inOut',
            }, 0);
            revealTl.to('.project-detail__header-image', {
                duration: 2, scale: 1, ease: 'power2.out',
            }, 0);
        },
    },
});
